import React from "react"
import classnames from "classnames"
import { AnimatedPlusMinus } from "containers"
import { A, ChevronIcon } from "AtomicComponents"
import componentParser from "AtomicUtils/componentParser";
import gtmHandler from "AtomicUtils/gtmHandler"
import styles from "./AccordionText.less"

class AccordionText extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      status: 0,
      height: 0
    }
  }

  componentDidMount(){
    const { status, isExpandedByDefault = false } = this.props
    if ((status === 1 || isExpandedByDefault) && this.contentArea){
      setTimeout(() => {
        this.setState({
          status: 1,
          height: this.contentArea ? this.contentArea.scrollHeight : 0
        })
      }, 200)
    }
  }

  _handleOnClick = () => {
    const { onClick = () => { }, gtm, title, name } = this.props
    const { status } = this.state
    this.setState({
      status: status === 1 ? 0 : 1,
      height: status === 0 && this.contentArea ? this.contentArea.scrollHeight : 0
    }, () => {
      onClick(this.state.status)

      // Delay for firing GTM before redirection
      // Call GTM if we have an gtm object
      if (gtm && gtm.category && gtm.action && gtm.category !== "" && gtm.action !== "") {
        const heading = title || name
        gtmHandler({
          pageCategory: gtm.category,
          pageAction: gtm.action + ` - "${this.state.status === 1 ? "EXPANDED" : "COLLAPSED"}"` + ` "${heading.toUpperCase()}"`
        })
      }
    })
  }

  updateHeight = (el) => {
    const { status, height } = this.state

    if (el && status === 1 && height !== el.scrollHeight) {
      setTimeout(() => {
        this.setState({
          height: el.scrollHeight
        })
      }, 200)
    }
  }

  render() {
    const { styleName = "box", children, title, name, components, titleTextAlign } = this.props
    const { height, status } = this.state
    const heading = title || name
    const description = children || componentParser(components)

    return (
      <div>
        <div
          className={classnames({
            [styles.AccordionText]: true
          })}>
          <div
            data-test="accordion-title"
            className={classnames({
              [styles.AccordionTitle]: true
            })}>
            {styleName === 'simple'&&
              <A
                onClick={this._handleOnClick}
                styleName="blue"
              >
                {heading}
              </A>
            }
            {styleName === 'box'&&
              <div
                className={classnames({
                  [styles.AccordionTitleBox]: true,
                  [styles.AccordionCenterAligned]: titleTextAlign === 'center'
                })}
                onClick={this._handleOnClick}>
                <span className={classnames({
                  [styles.AccordionTitleBoxText]: true
                })}>{heading}</span>
                {description &&
                  <span className={classnames({
                    [styles.AccordionTitleBoxIcon]: true
                  })}>
                    <AnimatedPlusMinus open={status} />
                  </span>
                }
              </div>
            }
            {styleName === 'disclaimer' &&
              <div
                onClick={this._handleOnClick}
                className={classnames({
                  [styles.AccordionTitleDisclaimer]: true
                })}>
                <label>{heading}</label>
                <span className={classnames({
                  [styles.AccordionTitleDisclaimerIcon]: true
                })}>
                  <ChevronIcon style={{ transform: status ? 'none' : 'rotate(180deg)' }} />
                </span>
              </div>
            }
          </div>
          <div
            ref={c => this.contentArea = c}
            className={classnames({
              [styles.AccordionContent]: true,
              [styles.AccordionContentBox]: styleName === 'box',
              [styles.AccordionContentDisclaimer]: styleName === 'disclaimer',
              [styles.AccordionContentInfo]: styleName === 'info'
            })}
            style={{
              height: `${height}px`
            }}
          >
            <div
              ref={el => this.updateHeight(el)}
              className={classnames({
                [styles.AccordionContentInside]: true,
                [styles.LefAligned]: styleName === 'box' || styleName === 'info'
              })}>
              {description}
            </div>
          </div>
          {styleName === 'info' &&
            <div
              className={classnames({
                [styles.AccordionTitleInfo]: true
              })}
              onClick={this._handleOnClick}>
              <span className={classnames({
                [styles.AccordionTitleInfoIcon]: true
              })}>
                <AnimatedPlusMinus open={status} />
              </span>
              <span className={classnames({
                [styles.AccordionTitleInfoText]: true
              })}>{status ? "Less Info" : "More Info"}</span>
            </div>
          }
        </div>

      </div>
    )
  }
}

export default AccordionText



// WEBPACK FOOTER //
// ./src/AtomicContainers/AccordionText/AccordionText.jsx